<template>
  <div>

    <div class="h-panel">
      <b-button v-b-modal.help-modal>Help</b-button>
    </div>

    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <template v-if="tmnts !== null && tmnts.length > 0">
      <contest-rewards
        v-for="tmnt in tmnts"
        :key="tmnt.id"
        :tmnt="tmnt"
        class="contest-rewards"
      />
    </template>

    <b-modal id="help-modal" title="Справка" ok-only ok-title="Close">
      <div class="help">
        <p>
          На&nbsp;данной странице показаны награды игрока за&nbsp;участие в&nbsp;конкурсах.
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { HTTP } from '../http-common';
import notifier from '../notifier';
import LoadingIndicator from './LoadingIndicator.vue';
import ContestRewards from './PlayerContestRewards.vue';
import { findObjectById } from '../util';

export default {
  name: 'PlayerContestsRewards',

  components: {
    LoadingIndicator,
    ContestRewards,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      isLoading: false,
      tmnts: null,
    };
  },

  computed: {
    message() {
      if(this.tmnts !== null && this.tmnts.length === 0) {
        return 'No rewards.';
      }
      return null;
    },
  },

  created() {
    notifier.deleteSenderNotifications(this);
    this.isLoading = true;

    const url = `/player/${this.playerId}/contests_rewards`;
    HTTP.get(url)
    .then(response => {
      this.isLoading = false;

      const data = response.data.data;
      if(data === null) {
        notifier.showError('Invalid server response. data === null.', {sender: this});
        return;
      }

      const rewards = data;
      const tmnts = groupTmnts(rewards);

      this.tmnts = tmnts;
    })
    .catch(e => {
      this.isLoading = false;
      notifier.showError(e.response.data, {sender: this});
    });
  },
};

function groupTmnts(rewards) {
  const tmnts = [];
  for(let i = 0; i < rewards.length; i++) {
    const reward = rewards[i];
    let tmnt = findObjectById(tmnts, reward.tmnt_id);
    if(tmnt === null) {
      tmnt = {
        id: reward.tmnt_id,
        rewards: [],
      }
      tmnts.push(tmnt);
    }
    tmnt.rewards.push(reward);
  }
  return tmnts;
}
</script>

<style scoped>
.contest-rewards {
  margin-bottom: 3em;
}
</style>
